export default __webpack_public_path__ + "static/media/Binance-Icon-Logo.wine.4128d781.png";